import { Rescatable } from '../Rescatable';
import { Incluidos } from '../Incluidos';
import { Niveles } from '../Niveles';
import { Caracteristicas } from '../Caracteristicas';
import { Product } from './Product';

export class ProductDetails extends Rescatable {
  static _name = 'ProductDetails';
  static pathRequest = Rescatable.pathRequestStatic + 'productos_caracteristicas';
  static pathRequestIndex = Rescatable.pathRequestStatic + 'productos_caracteristicas';
  static pk: keyof ProductDetails = 'id_producto';

  id_producto: number;
  caracteristicas: Caracteristicas;
  incluidos: Incluidos[];
  niveles: Niveles;
  $product: Product;
  constructor(e: ProductDetails) {
    super(e);
  }
}
